
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller/dashboard/page/[slug]",
      function () {
        return require("private-next-pages/seller/dashboard/page/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seller/dashboard/page/[slug]"])
      });
    }
  